"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PurchasePlans;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const useDevice_1 = require("../../hooks/useDevice");
const colors_1 = require("../../common/colors");
const AppText_1 = require("../../component/AppText");
const NewPricingCard_1 = __importDefault(require("../../component/NewPricingCard"));
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const purchases_1 = require("../../services/purchases");
const commonFeatures = [
    "AI-powered summarization",
    "Unlimited Notes",
    "Share Notes with password",
    "Edit Summaries"
];
function PurchasePlans() {
    const { deviceWidth } = (0, useDevice_1.useDevice)();
    const isSmallScreen = deviceWidth <= 840;
    const { request } = (0, useRequest_1.default)();
    const [plans, setPlans] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const fetchPlans = async () => {
            try {
                const response = await request(purchases_1.getPlans);
                if (response) {
                    setPlans(response);
                }
            }
            catch (error) {
                console.error('Error fetching plans:', error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchPlans();
    }, [request]);
    if (loading) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { source: require("../../assets/icons/lottie/spinner.json"), autoPlay: true, loop: true, autoSize: true, resizeMode: "cover", style: {
                    height: 64,
                } }) }));
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { style: { width: '100%' }, contentContainerStyle: { flexGrow: 1 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.content, isSmallScreen && styles.contentMobile], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.header, isSmallScreen && styles.headerMobile], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: 'white', fontSize: isSmallScreen ? 32 : 40, fontWeight: 600, lineHeight: isSmallScreen ? 44 : 48, marginBottom: 5, letterSpacing: -0.64, justifyContent: 'center', children: "Choose Your Summaraizer Plan" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_100, fontSize: 18, lineHeight: 28, textAlign: "center", style: styles.description, children: "Get instant, accurate summaries powered by advanced AI technology. Select the plan that best fits your needs." })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.cardsContainer, isSmallScreen && styles.cardsContainerMobile], children: plans.slice().reverse().map((plan, index) => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                                styles.card,
                                isSmallScreen && styles.cardMobile,
                                index > 0 && !isSmallScreen && { marginLeft: 32 }
                            ], children: (0, jsx_runtime_1.jsx)(NewPricingCard_1.default, { title: plan.summariesLimit === 250 ? 'The Boss' :
                                    plan.summariesLimit === 100 ? 'The Pro' :
                                        'The Starter', price: plan.price, summaries: plan.summariesLimit, messages: plan.conversationLimit, isPopular: plan.summariesLimit === 250, features: commonFeatures, planId: plan.stripePlanId }) }, plan.id))) })] }) }) }));
}
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors_1.Colors.DARK_700,
        justifyContent: 'center',
        alignItems: 'center',
    },
    content: {
        maxWidth: 1152, // equivalent to max-w-6xl
        alignSelf: 'center',
        width: '100%',
        paddingHorizontal: 32,
        paddingVertical: 80,
    },
    contentMobile: {
        paddingHorizontal: 16,
        paddingVertical: 40,
    },
    header: {
        alignItems: 'center',
        marginBottom: 64,
    },
    headerMobile: {
        marginBottom: 32,
    },
    description: {
        maxWidth: 672, // equivalent to max-w-2xl
        marginHorizontal: 'auto',
    },
    cardsContainer: {
        flexDirection: 'row',
        maxWidth: 1024, // equivalent to max-w-5xl
        marginHorizontal: 'auto',
    },
    cardsContainerMobile: {
        flexDirection: 'column',
        gap: 16,
    },
    card: {
        flex: 1,
    },
    cardMobile: {
        width: '100%',
    },
});
